module.exports = __webpack_public_path__ + "static/media/tongue-min.3c7a8404.png";